(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Bootstrap Offcanvas Polyfill
  if (typeof bootstrap === 'undefined' || !bootstrap.Offcanvas) {
    window.bootstrap = window.bootstrap || {};
    
    // Simple Offcanvas implementation
    bootstrap.Offcanvas = class Offcanvas {
      constructor(element) {
        this.element = element;
      }
      
      show() {
        // Get the offcanvas element
        const element = this.element;
        if (!element) return;
        
        // Show the offcanvas
        element.classList.add('show');
        
        // Add backdrop
        const backdrop = document.createElement('div');
        backdrop.classList.add('offcanvas-backdrop', 'fade', 'show');
        document.body.appendChild(backdrop);
        
        // Prevent body scroll
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = '15px';
        
        // Handle backdrop click
        backdrop.addEventListener('click', () => this.hide());
        
        // Handle close button click
        const closeButton = element.querySelector('[data-bs-dismiss="offcanvas"]');
        if (closeButton) {
          closeButton.addEventListener('click', () => this.hide());
        }
        
        // Trigger show event
        element.dispatchEvent(new CustomEvent('shown.bs.offcanvas'));
      }
      
      hide() {
        // Get the offcanvas element
        const element = this.element;
        if (!element) return;
        
        // Hide the offcanvas
        element.classList.remove('show');
        
        // Remove backdrop
        const backdrop = document.querySelector('.offcanvas-backdrop');
        if (backdrop) backdrop.remove();
        
        // Restore body scroll
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        
        // Trigger hide event
        element.dispatchEvent(new CustomEvent('hidden.bs.offcanvas'));
      }
    };
  }

  // Ensure header styling is consistent across all pages with exactly 15px padding
  document.addEventListener('DOMContentLoaded', function() {
    // Force consistent styling across all pages
    function enforceHeaderConsistency() {
      const header = document.querySelector('.header-wrapper');
      const headerInner = document.querySelector('.header');
      const headerHeading = document.querySelector('.header__heading');
      const headerLink = document.querySelector('.header__heading-link');
      
      if (header) {
        // Force fixed position and consistent styling on header wrapper
        Object.assign(header.style, {
          position: 'fixed',
          top: '0',
          left: '0',
          right: '0',
          margin: '0',
          padding: '0',
          width: '100%',
          backgroundColor: '#ffffff',
          zIndex: '1000',
          borderBottom: 'none',
          boxShadow: 'none'
        });
      }
      
      if (headerInner) {
        // Force exactly 15px padding on all sides
        Object.assign(headerInner.style, {
          padding: '15px',
          margin: '0',
          boxSizing: 'border-box',
          height: 'auto',
          maxWidth: 'none'
        });
      }
      
      if (headerHeading) {
        // Consistent heading styles
        Object.assign(headerHeading.style, {
          margin: '0',
          padding: '0',
          lineHeight: 'normal'
        });
      }
      
      if (headerLink) {
        // Consistent link styles
        Object.assign(headerLink.style, {
          display: 'inline-block',
          padding: '0',
          margin: '0',
          color: '#000000',
          fontSize: window.innerWidth < 750 ? '17px' : 'inherit'
        });
      }
      
      // Force consistent body padding based on header height
      const headerHeight = headerInner ? headerInner.offsetHeight : 65;
      document.body.style.paddingTop = headerHeight + 'px';
      
      // Override any potential template-specific styles using !important inline styles
      const styleTag = document.createElement('style');
      styleTag.textContent = `
        .header { 
          padding: 15px !important; 
          margin: 0 !important; 
          max-width: none !important;
          box-sizing: border-box !important;
          border-bottom: none !important;
          box-shadow: none !important;
        }
        .header-wrapper {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          z-index: 1000 !important;
          border-bottom: none !important;
          box-shadow: none !important;
        }
        /* Target every possible template */
        .template-index .header,
        .template-collection .header,
        .template-product .header,
        .template-article .header,
        .template-blog .header,
        .template-list-collections .header,
        .template-page .header,
        .template-search .header,
        .template-cart .header,
        .template-customers-account .header,
        .template-customers-addresses .header,
        .template-customers-login .header,
        .template-customers-order .header,
        .template-customers-register .header,
        .template-customers-reset-password .header,
        .template-gift-card .header,
        .template-404 .header {
          padding: 15px !important;
        }
      `;
      document.head.appendChild(styleTag);
    }
    
    // Run immediately 
    enforceHeaderConsistency();
    
    // Also on resize
    window.addEventListener('resize', enforceHeaderConsistency);
    
    // Run after slight delays to override any theme scripts that might load later
    setTimeout(enforceHeaderConsistency, 100);
    setTimeout(enforceHeaderConsistency, 500);
    setTimeout(enforceHeaderConsistency, 1000);
    
    // Set an interval to continuously check and enforce consistency
    // This ensures it works across all pages even with dynamic content loading
    setInterval(enforceHeaderConsistency, 2000);
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = true; // Changed to true since we're using fixed header
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Add sticky class for fixed header
      this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const headerHeight = `${this.header.offsetHeight}px`;
      document.documentElement.style.setProperty('--header-height', headerHeight);
      document.body.style.paddingTop = headerHeight;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Ensure no border or shadow is applied when scrolling
      this.header.classList.remove('scrolled-past-header');
      this.header.style.borderBottom = 'none';
      this.header.style.boxShadow = 'none';

      this.currentScrollTop = scrollTop;
    }

    hide() {
      // We want the header to stay visible, so just handle menu/search closing
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      // Header is always visible with fixed positioning
    }

    reset() {
      // Header position is fixed, no need to reset
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Disable double-tap zoom
  document.addEventListener('DOMContentLoaded', function() {
    // Apply to header element and all its children
    const header = document.querySelector('.header-wrapper');
    if (header) {
      // Prevent all touch gestures that could trigger zoom
      function preventZoom(e) {
        if (e.touches && e.touches.length > 1) {
          e.preventDefault();
        }
      }
      
      // Add listeners to prevent zoom gestures
      ['touchstart', 'touchmove', 'touchend', 'gesturestart', 'gesturechange', 'gestureend'].forEach(function(event) {
        header.addEventListener(event, preventZoom, { passive: false });
      });
      
      // Prevent double-tap zoom
      let lastTap = 0;
      header.addEventListener('touchend', function(e) {
        const currentTime = new Date().getTime();
        const tapLength = currentTime - lastTap;
        if (tapLength < 300 && tapLength > 0) {
          e.preventDefault();
        }
        lastTap = currentTime;
      }, false);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
